<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 512 512">
  @if (tooltip) {
    <title>{{ tooltip }}</title>
  }
  <path
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="48"
    d="M184 112l144 144-144 144"/>
  </svg>
